const admin_en = require('./admin.json')
export default admin_en